import React from "react";

export default function PaidTooltipContent({
  otherPersonPaid,
  payerName,
  amountToDisplay,
  dateText,
  markedPaidName,
  status,
}) {
  if (status === "MarkedAsPaid")
    return (
      <div>
        Marked as paid by <strong>{markedPaidName}</strong>
      </div>
    );

  if (status === "Paid")
    return (
      <div>
        <div style={{ marginBottom: "8px" }}>
          {otherPersonPaid && payerName ? (
            <span>
              Paid by <strong>{payerName}</strong> via Flocknote
            </span>
          ) : (
            "Paid via Flocknote"
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>{amountToDisplay}</div>
          <div>{dateText}</div>
        </div>
      </div>
    );

  return null;
}
